module.exports = __webpack_public_path__ + "img/icn_download.de91c5ac.svg";